import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion';
import { appActions, appSelectors, TRANSACTION_STATE } from '../../app/reducer/app-reducer';
import { appMainBackground, white, defaultBoxShadow } from '../../../styles/colors';
import { menuStyle } from '../../../styles/LaunchpadDropdownStyle';
import { authSelectors } from '@rosetta/react-auth';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { getLearnerSelectLearningLanguages } from '../../app/services/language-helpers';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import { LOGIN_STATUS } from '@rosetta/react-auth/dist/index';
import { isMobile as isMobileDetected } from 'react-device-detect';

let isRtl = false;
let boxSidePadding = 22;

const SelectTargetLanguageDiv = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'relative',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appMainBackground
  };
  if (props.isMobile) {
    style.minHeight = props.windowHeight - 250 + 'px';
  }
  return style;
});

const SelectTargetLanguageBox = styled.div((props) => {
  let style = {
    backgroundColor: !props.isMobile ? white : appMainBackground,
    padding: !props.isMobile ? '30px 30px 30px 30px' : '16px',
    borderRadius: '4px',
    maxWidth: !props.isMobile ? '340px' : '400px',
    boxShadow: !props.isMobile ? defaultBoxShadow : 'none'
  };
  return style;
});

const TitleTextDisp = styled.div(() => {
  let style = {
    fontSize: '20px',
    lineHeight: '33px',
    textAlign: 'center',
    fontWeight: '200',
    letterSpacing: '1px',
    margin: '0 -30px 31px',
    paddingLeft: boxSidePadding,
    paddingRight: boxSidePadding,
    paddingBottom: '12px',
    borderBottomColor: appMainBackground,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid'
  };
  return style;
});

const PromptTextDisp = styled.div(() => {
  let style = {
    fontSize: '18px',
    lineHeight: '22px',
    textAlign: 'center',
    fontWeight: '300',
    marginBottom: '20px'
  };
  return style;
});

const LanguageMenu = styled.div((props) => {
  let style = {
    width: '100%',
    height: 40,
    marginBottom: '18px'
  };
  return style;
});

const SelectTargetLanguageButton = styled(LaunchpadButton)((props) => {
  let style = {
    width: '100%',
    borderRadius: '20px',
    fontSize: '16px'
  };
  return style;
});

const ErrorDisp = styled.div((props) => {
  let style = {
    marginTop: '25px',
    fontSize: '16px',
    lineHeight: '18px'
  };
  return style;
});

//*********************************************
export class SelectTargetLanguage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguageCode: ''
    };
    this.props.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION);
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.isAppInitialized && nextProps.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      nextProps.history.push('/login');
    }
    return null;
  };

  handleLanguageSelected = (languageObj) => {
    this.setState({ selectedLanguageCode: languageObj.value });
  };

  handleNextButtonClick = (event) => {
    this.props.setUserTargetLanguage(this.state.selectedLanguageCode);
  };

  isNextButtonDisabled = () => {
    return this.state.selectedLanguageCode === '';
  };

  // ****** render
  render = () => {
    if (this.props.lastTransactionState === TRANSACTION_STATE.PENDING) {
      return <MouseCatcher />;
    }
    if (!this.props.lionLoaded) {
      return null;
    }

    isRtl = this.props.isInterfaceRtl;

    let errorDisp = null;
    if (this.props.lastTransactionState === TRANSACTION_STATE.FAIL) {
      errorDisp = (
        <ErrorDisp data-qa="ErrorDisp">
          {this.props.lionTranslateString('system_error_internal_service_error_(500)')}
        </ErrorDisp>
      );
    }

    return (
      <SelectTargetLanguageDiv data-qa="SelectTargetLanguage" isMobile={isMobileDetected}>
        <SelectTargetLanguageBox isMobile={isMobileDetected}>
          <TitleTextDisp>{this.props.lionTranslateString('_sso_start_language_journey')}</TitleTextDisp>
          <PromptTextDisp>{this.props.lionTranslateString('_select_language_to_learn')}</PromptTextDisp>

          <LanguageMenu isMobile={isMobileDetected}>
            <RSDropdown
              dataQa="LanguageMenu"
              menuTabIndex={1}
              isRtl={isRtl}
              buttonText={this.props.lionTranslateString('_select_language')}
              itemsList={this.props.localizedLearningLanguages()}
              itemDisplayProperty="label"
              itemKeyProperty="value"
              onSelectionHandler={this.handleLanguageSelected}
              selectedKey={this.state.selectedLanguageCode}
              menuStyle={menuStyle}
            />
          </LanguageMenu>

          <SelectTargetLanguageButton
            data-qa="SelectTargetLanguageButton"
            onClick={this.handleNextButtonClick}
            disabled={this.isNextButtonDisabled()}
          >
            {this.props.lionTranslateString('next')}
          </SelectTargetLanguageButton>
          {errorDisp}
        </SelectTargetLanguageBox>
      </SelectTargetLanguageDiv>
    );
  };
}

SelectTargetLanguage.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  localizedLearningLanguages: () => {
    return getLearnerSelectLearningLanguages(state);
  },
  lastTransactionState: appSelectors.lastTransactionState(state),
  loginStatus: authSelectors.loginStatus(state),
  isAppInitialized: appSelectors.isAppInitialized(state)
});

const wrapActions = {
  setUserTargetLanguage: appActions.setUserTargetLanguage,
  setLastTransactionState: appActions.setLastTransactionState
};
export const SelectTargetLanguageContainer = connect(
  mapStateToProps,
  wrapActions
)(SelectTargetLanguage);



// WEBPACK FOOTER //
// ./src/modules/login/components/SelectTargetLanguage.jsx